export { SmallBusinessSvg } from './SmallBusiness';
export { GeneralLiabilitySvg } from './GeneralLiability';
export { ProfessionalLiabilitySvg } from './ProfessionalLiability';
export { BusinessPolicySvg } from './BusinessPolicy';
export { WorkersCompensationSvg } from './WorkersCompensation';
export { StandingGirlSvg } from './StandingGirl';
